import React from 'react';

const Ground = () => {
  return <div className="ground"></div>;
};

export default Ground;